(function(){
  var nav=document.querySelector('.nav'),bar=document.querySelector('.buybar'),offer=document.getElementById('angebot'),hero=document.querySelector('.hero');
  function onScroll(){
    nav.classList.toggle('solid',scrollY>10);
    var o=offer.getBoundingClientRect(),h=hero.getBoundingClientRect();
    bar.classList.toggle('show',h.bottom<0 && !(o.top<innerHeight && o.bottom>0));
  }
  addEventListener('scroll',onScroll,{passive:true});addEventListener('resize',onScroll);onScroll();

  // bundles
  var total=document.querySelector('[data-total]'),bb=document.querySelector('[data-bb-price]');
  document.querySelectorAll('.bundle').forEach(function(b){
    b.addEventListener('click',function(){
      document.querySelectorAll('.bundle').forEach(function(x){x.classList.remove('sel')});
      b.classList.add('sel');b.querySelector('input').checked=true;
      total.textContent=b.dataset.price;bb.textContent=b.dataset.price;document.querySelector('[data-cta-price]').textContent=b.dataset.price;
    });
  });
  // gallery
  var main=document.getElementById('mainImg');
  document.querySelectorAll('.thumbs button').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.thumbs button').forEach(function(x){x.classList.remove('sel')});
      t.classList.add('sel');main.src=t.dataset.src;
    });
  });
  // checkout: Shopify cart permalink of the selected bundle variant; ad + ClickMagick params ride along as order attributes
  var FK_TRACK=(function(){var k=['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','gbraid','wbraid','fbclid','cmc_vid','cmc_adid'],q=new URLSearchParams(location.search),t={};
    try{t=JSON.parse(sessionStorage.getItem('fk_track')||'{}')}catch(e){}
    k.forEach(function(n){var v=q.get(n);if(v)t[n]=v.slice(0,250)});try{sessionStorage.setItem('fk_track',JSON.stringify(t))}catch(e){}return t})();
  /* keys are prefixed 'ad_': cmc.js rewrites any [utm_source]/[gclid]/[cmc_vid] text inside links into its value */
  function cartUrl(){var sel=document.querySelector('.bundle.sel'),i=sel&&sel.dataset.sku==='2'?1:0,v=(window.FK_VARIANTS||[])[i];if(!v)return '#angebot';
    var u=new URLSearchParams(),cm=window.clickmagick_cmc;u.set('attributes[ad_landing_page]','frostkant-de');
    Object.keys(FK_TRACK).forEach(function(n){u.set('attributes[ad_'+n+']',FK_TRACK[n])});if(cm&&cm.vid)u.set('attributes[ad_cm_visitor]',cm.vid);
    return (window.FK_ROOT||'/').replace(/\/$/,'')+'/cart/'+v+':1?'+u.toString()}
  var buy=document.querySelector('[data-buy]');buy.addEventListener('click',function(){buy.href=cartUrl()});
  buy.href=cartUrl();document.querySelectorAll('.bundle').forEach(function(b){b.addEventListener('click',function(){buy.href=cartUrl()})});
  // compare table labels for mobile cards
  var heads=[].map.call(document.querySelectorAll('.cmp thead th'),function(th){return th.textContent.replace('­','')});
  document.querySelectorAll('.cmp tbody tr').forEach(function(r){[].forEach.call(r.cells,function(c,i){if(c.tagName==='TD')c.setAttribute('data-l',heads[i])})});
  // pause hero video off screen
  var v=document.getElementById('hv');
  if(v&&!matchMedia('(prefers-reduced-motion: reduce)').matches){v.src=innerWidth<=760?window.FK_VID.m:window.FK_VID.d;v.preload='auto'}
  if(v&&'IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause()})}).observe(v)}
  if(matchMedia('(prefers-reduced-motion: reduce)').matches&&v){v.removeAttribute('autoplay');v.pause()}
  // reveal
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('[data-rev]').forEach(function(el){io.observe(el)});
})();
